import axios from 'axios';
import Request from '../lib/request';
import { PICTURE_TYPE, COS_TYPE } from '../pages/registerv2/enum';

const api = {};

api.getPutUrl = async (data) => {
  const { name, type = PICTURE_TYPE.default, cosType = COS_TYPE.common } = data;
  let res;
  if (cosType === COS_TYPE.private) {
    res = await Request({
      url: 'v1/certification/upload_url',
      method: 'post',
      data: {
        file_name: name,
        pic_type: type,
      },
    });
    const { upload_url: uploadUrl, path, download_url: downloadUrl } = res || {};
    if (uploadUrl && path && downloadUrl) {
      return { uploadUrl, path, downloadUrl };
    }
  }
  if (cosType === COS_TYPE.common) {
    res = await Request({
      url: 'v1/cos/get_upload_url',
      method: 'post',
      data: {
        file_name: name,
        func: type,
      },
    });
    const { Sign: uploadUrl, Url: downloadUrl } = res || {};
    if (uploadUrl && downloadUrl) {
      return { uploadUrl, path: downloadUrl, downloadUrl };
    }
  }
  throw new Error(res);
};

api.uploadPicture = async (data) => {
  const { name, file, type = PICTURE_TYPE.default, cosType } = data;
  if (!name || !file) return Promise.reject({ errorMsg: '参数缺失' });
  try {
    const { uploadUrl, path, downloadUrl } = await api.getPutUrl({ name, type, cosType });
    await axios.put(uploadUrl, file);
    return { path, downloadUrl };
  } catch (err) {
    throw new Error(err);
  }
};

// 发送短信验证码
api.getSmsCode = (
  reqData = {},
  autoErrorTips = true
) => Request({
  url: 'v1/account/smscode/send_verify',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 验证短信验证码
api.verifySmsCode = (
  reqData = {
    phone_number: '',
    code: '',
  },
  vueContext,
  autoErrorTips = true,
) => {
  const apiPromise = Request({
    url: 'v1/account/smscode/verify',
    method: 'post',
    data: reqData,
    autoErrorTips: false, // 拦截请求库的自动报错功能
  });

  apiPromise
    .then((res) => {
      if (autoErrorTips && vueContext) {
        const code = Number(res?.head?.code);

        if (code === 5101) {
          const errorMsg = `[${code}] 验证码错误或已过期`;
          vueContext?.$message && vueContext?.$message.error(errorMsg);
          return;
        };

        if (code !== 0) {
          const errorMsg = `[${code}] 短信验证码验证失败`;
          vueContext?.$message && vueContext?.$message.error(errorMsg);
          return;
        };
      }
    });

  return apiPromise;
};

/**
  获取商品类目
  rsp示例：
  {
    "categories": [
      {
        "cat_name": "精品男装", // 类目名称
        "cat_id": 1, // 类目id
        "cat_level": 1, // 类目级别
        "parent_cat_id": 0, // 父级类目id
      },
      {
        "cat_name": "宠物用品",
        "cat_id": 2,
        "cat_level": 1,
        "parent_cat_id": 0,
      },
      {
        "cat_name": "数码电器",
        "cat_id": 3,
        "cat_level": 1,
        "parent_cat_id": 0,
      }
    ]
  }
 */
api.getCategory = (reqData = {}) => Request({
  url: 'v1/product/cat_query_list',
  method: 'post',
  data: reqData,
});

/**
  获取用户橱窗列表
  rsp示例：
  {
    "head": {
      "code": "0",
      "msg": "Succeed",
    },
    "media_infos": [
      {
        "media_id": "1001194",
        "media_type": 2,
        "uid": "85931",
        "id": "4",
        "media_mask": "kg",
        "media_name": "全民k歌",
        "user_name": "",
        "avatar_url": "",
        "ext_info": "",
        "distribution_invite_code": "",
        "state": 1,
        "is_delete": 0,
        "remark": ""
      },
      {
        "media_id": "test_ws",
        "media_type": 1,
        "uid": "85931",
        "id": "15",
        "media_mask": "ws",
        "media_name": "微视",
        "user_name": "",
        "avatar_url": "",
        "ext_info": "",
        "distribution_invite_code": "",
        "state": 1,
        "is_delete": 0,
        "remark": ""
      },
    ]
  }
 */
api.getMediaList = (reqData = {
  block_by_eshop: true, // true 只展示ESHOP可展示的用户橱窗；false 展示所有用户橱窗
  media_type: undefined, // String, 指定筛选的媒体类型，如：kg、om、qq，默认不筛选，非必传字段
}, autoErrorTips = true) => Request({
  url: 'v3/user/media_list',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 获取拼多多绑定状态
api.getPddBindingStatus = (
  reqData = {
    code: '',
    action: 2,
  },
  autoErrorTips = true
) => Request({
  url: 'v3/pdd/binding',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

export default api;
